<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="캠페인명" label-width="100px">
                <el-input type="text" v-model="search.campaignNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="검색일자" label-width="100px">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker type="date" placeholder="시작일" v-model="search.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                  <el-col :span="1" style="text-align: start;">-</el-col>
                  <el-col :span="12">
                    <el-date-picker type="date" placeholder="종료일" v-model="search.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="진행상태" label-width="100px">
                <el-select v-model="search.campaignStatus">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['campaignStatus']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="유형" label-width="100px">
                <el-select v-model="search.campaignType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['campaignType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="상담원" label-width="100px">
                <el-col v-if="this.$store.state.loginInfo.groupUId == 3 || this.$store.state.loginInfo.groupUId == 6">
                  {{ this.$store.state.loginInfo.userName }}
                </el-col>
                <el-col v-else>
                  <el-select v-model="search.agentMember">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['agentMember']"
                        :key="item.value"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="inner-box">
      <div class="table-area">
        <div class="table-b">
          <div class="table-header">
            <div class="grid-tbl-box">
              <ag-grid-vue
                  ref="grid"
                  :style="gridStyle"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :column-defs="columnDefs"
                  :grid-options="mainGridOptions"
                  :row-data="data"
                  :default-col-def="defaultColDef"
                  :framework-components="frameworkComponent"
                  :statusBar="statusBar"
                  @grid-ready="onReadyMain"
                  @cell-clicked="onCellClicked" />
            </div>
          </div>
        </div>
      </div>

      <!-- 2번째 조회버튼 그리드 s.-->
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib"> </h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goDetail(2)">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 2번째 조회버튼 그리드 e.-->
      
      <!-- 분배일자 그리드 s.-->
      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="16">
              <el-form-item label="분배일자" label-width="100px">
                <el-row>
                  <el-col :span="11">
                    <el-date-picker type="date" placeholder="시작일" v-model="search2.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                  <el-col :span="1" style="text-align: start;">-</el-col>
                  <el-col :span="12">
                    <el-date-picker type="date" placeholder="종료일" v-model="search2.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="금일" label-width="100px">
                <el-select v-model="search2.todayType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['todayType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="처리결과" label-width="100px">
                <el-select v-model="search2.campaignCustStatus" @change="onSearhStatus1">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['campaignCustStatus']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              
                <el-select v-model="search2.campaignCustStatus2" @change="onSearhStatus2" v-show="search2.showSearchStatus2">
                  <el-option value='' label="선택">선택</el-option>
                  <el-option
                      v-for="item in combos['campaignCustStatus2']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              
                <el-select v-model="search2.campaignCustStatus3" v-show="search2.showSearchStatus3">
                  <el-option value='' label="선택">선택</el-option>
                  <el-option
                      v-for="item in combos['campaignCustStatus3']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 분배일자 그리드 e.-->
      
      <!-- 중간 그리드 s.-->
      <div class="table-area">
        <div class="table-b">
            <div class="table-header">
                <div class="table-name">
                </div>
                
                <div class="grid-tbl-box">
                    <ag-grid-vue 
                        ref="subGrid" 
                        :style="gridStyle"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                        :column-defs="subColumnDefs"
                        :grid-options="subGridOptions"
                        :row-data="subData"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        :statusBar="statusBar"
                        @grid-ready="onReadySub"
                        @cell-clicked="onSubCellClicked"
                        />
                </div>
            </div>
        </div>
      </div>
      <!-- 중간 그리드 e.-->

      <!-- 장애접수 상세내역 그리드 s.-->
      <div class="table-area">
        <div class="table-b">
            <div class="table-header">
                <div class="table-name">
                    <h3 class="ico_table_name">{{ `장애접수 상세내역` }}</h3>
                </div>
                
                <div class="grid-tbl-box">
                    <ag-grid-vue 
                        ref="subGrid" 
                        :style="gridStyle2"
                        class="ag-theme-alpine"
                        :enableRangeSelection="true"
                        :column-defs="subColumnDefs2"
                        :grid-options="subGridOptions2"
                        :row-data="subData2"
                        :default-col-def="defaultColDef"
                        :framework-components="frameworkComponent"
                        @grid-ready="onReadySub"
                        @cell-clicked="onSub2CellClicked"
                        />
                </div>
            </div>
        </div>
      </div>
      <!-- 장애접수 상세내역 그리드 e.-->
      <el-divider></el-divider>
      <!-- 처리결과에 만족하십니까 form s.-->
      <el-row :gutter="24">
        <el-col :span="5">
          <div class="sub-title">
              <div class="table-name">
                  <h3 class="ico_table_name">{{ `처리결과에 만족하십니까?` }}</h3>
              </div>
          </div>
        </el-col>
        
        <el-col :span="13">
          <el-radio-group v-model="saveForm.stisfactionType">
              <el-radio @change="onStypeChange"
                  v-for="item in combos['stisfactionType']"
                  :key="item.key"
                  :label="item.key"
                  :value="item.key"
                  :disabled=!btnSaveShow>{{ item.value }}
              </el-radio>
          </el-radio-group>
        </el-col>
        
        <el-col :span="6" v-show="btnSaveShow">
          <el-button type="success" icon="el-icon-check" @click="goSave" style="float: right;">
            저장
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form>
              <el-row>
                  <el-col :span="5">
                    <div class="sub-title">
                        <div class="table-name">
                            <h3 class="ico_table_name">처리결과</h3>
                        </div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <el-select v-model="saveForm.svCampaignCustStatus1" @change="onCustStatusChange1" :disabled=!btnSaveShow>
                      <el-option value='' label="선택">선택</el-option>
                      <el-option
                          v-for="item in combos['svCampaignCustStatus1']"
                          :key="item.value"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="7">
                    <el-select v-model="saveForm.svCampaignCustStatus2" @change="onCustStatusChange2" v-show="showCustStatus2" :disabled=!btnSaveShow>
                      <el-option value='' label="선택">선택</el-option>
                      <el-option
                          v-for="item in combos['svCampaignCustStatus2']"
                          :key="item.value"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="6">
                    <el-select v-model="saveForm.svCampaignCustStatus3" v-show="showCustStatus3" :disabled=!btnSaveShow>
                      <el-option value='' label="선택">선택</el-option>
                      <el-option
                          v-for="item in combos['svCampaignCustStatus3']"
                          :key="item.value"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
              </el-row>
          </el-form>
        
        </el-col>

      </el-row>
      <!-- 처리결과에 만족하십니까 e.-->

      <!-- 주문메모 text area s.-->
      <div class="table-area">
          <div class="table-b" style="margin-bottom: 0px;">
              <el-row :gutter="24">
                  <el-col>
                      <div class="sub-title">
                          <div class="table-name">
                              <h3 class="ico_table_name">{{ `사유` }}</h3>
                          </div>
                      </div>
                      <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 6}"
                      placeholder="사유를 작성하세요."
                      v-model="saveForm.description"
                      :readonly=!btnSaveShow
                      >
                      </el-input>
                      <div class="grid-content bg-purple"></div>
                  </el-col>
              </el-row>
              <div><span class="wave">&nbsp;</span></div>
          </div>
      </div>
      <!-- 주문메모 text area e.-->


    </div>
  </div>
</template>

<script>
/**
 * * mixins
 */
 import lucoms from '@/mixin/lucoms';

import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import ReceptionModal from '@/components/AS/History/Modal/ReceptionModal.vue';

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

/**
 * 콤마표시
 * @param {*} val 
 */
 function comma(val){
    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

export default {
  mixins: [lucoms],
  props: {
  },
  data() {
    return {
      data: [],
      dataOrg:[], /** 조회후 데이타 백업 */
      subData: [],
      subDataOrg:[], /** 조회후 데이타 백업 */
      subData2: [],
      search: {
        companyId : '',
        campaignNm: '',
        startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        campaignStatus: '',        // 진행상태
        campaignType: '',          // 유형
        agentMember: (this.$store.state.loginInfo.groupUId==3 || this.$store.state.loginInfo.groupUId==6) ? this.$store.state.loginInfo.id : '',           // 상담원
        userId: '',                // 상담원
        sortType :  '',
        processTime : '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime: '',
        selCampaignId: ''
      },
      search2: {
        startDt: '',
        endDt: '',
        todayType: '',              // 금일
        campaignCustStatus: 'Distribution',     // 처리결과
        campaignCustStatus2: '',    // 처리결과2
        campaignCustStatus3: '',    // 처리결과3
        showSearchStatus2: false,   // 처리결과2 표시여부
        showSearchStatus3: false    // 처리결과3 표시여부
      },
      form: {
        custType: '', // 고객구분
        changeAsClass: '',  // 처리유형
        custNm: '', // 주문자명
        memo: '', // 주문메모
      },
      saveForm: {
        // 저장시 form
        asId: '',
        campaignId: '',
        campaignCustId: '',
        description: '',          // 사유
        stisfactionType: '',      // 처리결과 만족도
        svCampaignCustStatus1: '', // 처리결과
        svCampaignCustStatus2: '', // 처리결과
        svCampaignCustStatus3: '', // 처리결과
      },
      btnSaveShow: false,
      showCustStatus2: false,
      showCustStatus3: false,
      combos: {
        'campaignStatus': [],
        'campaignType': [],
        'agentMember': [],
        'todayType': [],
        'campaignCustStatus' : [],
        'campaignCustStatus2': [],
        'campaignCustStatus3': [],
        'svCampaignCustStatus1' : [],
        'svCampaignCustStatus2' : [],
        'svCampaignCustStatus3' : [],
        'stisfactionType' : [],
        'custType': [],
        'changeAsClass': [],
        'allCampaignCustStatus': []
      },
      startDt: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
      endDt: this.$moment().format('YYYY-MM-DD'),
      accountPrint: [],         // 세금계산서 발행
      showDeliverySave: false, 
      showDeliveryCancel: false,
      showPrintAccount: false,
      selGridIdx: -1,   // 선택된 첫번째 그리드 index : 색깔 변경용 
      selGridIdx2: -1,  // 선택된 두번째 그리드 index : 색깔 변경용

      selIdx: -1,   // 선택된 첫번째 그리드 index
      selIdx2: -1,  // 선택된 두번째 그리드 index
      
      // AG-GRID OPTION [START]
      gridStyle : 'width: 100%; height: 230px; min-height:100px;',
      gridStyle2 : 'padding-top: 40px; width: 100%; height: 230px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter: true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      subGridApi: null,
      subColumnApi: null,
      subGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      subGridApi2: null,
      subColumnApi2: null,
      subGridOptions2: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      subColumnDefs: [],
      subColumnDefs2: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init().finally(_ => {
        setTimeout(() => {
          this.goOpen();
        }, 500);
      });
    },
    onReadySub() {
      this.subGridApi = this.subGridOptions.api;
      this.subColumnApi = this.subGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          },
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }
        },
        {headerName:'캠페인명', field:'campaignNm', width:350,
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'left', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'left'};
                        }
                    }},
        {headerName:'시작일자', field:'startDt', width:110, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'종료일자', field:'endDt', width:110, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'유형', field:'campaignType', width:110, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'유형', field:'campaignTypeNm', width:110,
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'상태', field:'campaignStatus', width:110, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'상태', field:'campaignStatusNm', width:110,
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'총건수', field:'totalCnt', width:110, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'right', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'right'};
                        }
                    }},
        {headerName:'할당건수', field:'devideCnt', width:110,
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'right', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'right'};
                        }
                    }},
        {headerName:'완료건수', field:'doneCnt', width:110, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'right', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'right'};
                        }
                    }},
        {headerName:'미완료건수', field:'nondoneCnt', width:120,
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx){
                            return {textAlign: 'right', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'right'};
                        }
                    }},
      ];
    },
    createSubColumnDefs() {
      const vm = this;
      this.subColumnDefs = [
        {headerName:'캠페인명', field:'campaignNm', width:340, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx2){
                            return {textAlign: 'left', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'left'};
                        }
                    }},
        {headerName:'campaignId', field:'campaignId', width:140, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'campaignCustId', field:'campaignCustId', width:140, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'분배일자', field:'createDt', width:140, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx2){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'상담원', field:'userNm', width:160, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx2){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'고객구분', field:'custTypeNm', width:160, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx2){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'고객구분', field:'custType', width:160, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'사이트명', field:'siteNm', width:250, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx2){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'신고자명', field:'boundCustNm', width:160, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx2){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'연락처', field:'asTelNo', width:160, 
        cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx2){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'발신번호', field:'boundTelNo', width:160, 
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx2){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'처리결과', field:'campaignCustStatusNm', width:160,
          cellStyle: (params) => {
                        const idx = params.rowIndex;
                        if(idx === this.selGridIdx2){
                            return {textAlign: 'center', backgroundColor: '#D5E6A3'};
                        } else {
                            return {textAlign: 'center'};
                        }
                    }},
        {headerName:'처리결과', field:'campaignCustStatus', width:160, cellStyle:{textAlign: 'center'}, hide:true}
      ];
    },
    createSubColumnDefs2() {
      const vm = this;
      this.subColumnDefs2 = [
        {headerName:'제조사', field:'makerNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'modelGroupNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'대표모델', field:'standardModelNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'모델', field:'modelNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'제조번호', field:'serialNo', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'접수유형', field:'asClassNm', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'접수유형', field:'asClass', width:150, cellStyle:{textAlign: 'center'}, hide:true},
        {headerName:'고장증상', field:'asRepairCatFullNm', width:300, cellStyle:{textAlign: 'center'}},
        {headerName:'접수내역', field:'callMemo', width:200, cellStyle:{textAlign: 'center'}},
        {headerName:'처리유형', field:'changeAsClassCdNm', width:160, cellStyle:{textAlign: 'center'}},
        {headerName:'처리유형', field:'changeAsClassCd', width:160, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'처리센터(처리자)', field:'allocationAsAgentNm', width:200, cellStyle:{textAlign: 'center'}}
      ];
    },
    onCellClicked(params) {
      const idx = params.rowIndex;
      const field = params.colDef.field;
      this.selGridIdx = idx;
      this.selIdx = idx;
      
      this.subData = [];
      this.subData2 = [];
      this.btnSaveShow = true;
      this.formClear();
      
      if(this.checkHideSubGrid(params.data)){
        this.subData = [];
        this.subDataOrg = [];
        this.subData2 = [];
        this.btnSaveShow = false;
      } else {
        this.search.selCampaignId = params.data.campaignId;
        this.goDetail(2, params.data.campaignId);
      }  

      this.mainGridApi.redrawRows({ rowNodes: params });
    },
    onSubCellClicked(params) {
      const idx = params.rowIndex;
      const field = params.colDef.field;
      console.log('params:', params)
      
      this.reloadSubCell(params);

    

    },
    onVisit(vObj){
      //연락처, 발신번호 클릭횟수저장

      this.$http
          .put('/api/boardMng/read',{
            companyId: this.$store.state.loginInfo.compCd,
            srcId1: "CAMPAIGN_CUST_BOUND",
            srcId2: vObj.campaignId,
            srcId3: vObj.campaignCustId,
            srcId4: "",
            creatorId: this.$store.state.loginInfo.id,
            processTime: "",
            visitorId: 0
          })
          .then(response => {
          })
          .catch(({ message }) => {
            if (message === "Request failed with status code 500") {
              this.$swal({ type: "error", text: "오류가 발생했습니다." });
            }
          });
    },
    reloadSubCell(params){
      // 3번째 그리드 재로딩 처리
      
      const vform = {
        asId: params.data.asId || '',
        campaignId: params.data.campaignId || '',
        campaignCustId: params.data.campaignCustId || '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime : ''
      };

      console.log('onSubCellClicked vform : ',params, vform)
      this.$http.post(_url("/api/asMng/happyCallList/selectHappyCallObstacle"), vform).then(response => {
        console.log('response.data' , response.data)
         
        this.getThirdData(response.data); // 세번째 그리드 조회

      }).catch((e) => {
        // console.error(e);
        // this.$swal({ type: 'success', text: '조회에 실패 했습니다.' })
    
      }).finally(() => {
        
        this.gridRefresh('sub'); // 그리드 색깔제거

        const idx = params.rowIndex;
        this.selGridIdx2 = idx;
        this.selIdx2 = idx;
      
        let rows = [];
        let rowNode = this.subGridApi.getDisplayedRowAtIndex(idx);

        if(params.gr2CustStatusChange === 'Y'){
          // 두번째 그리드를 로딩속도가 느려서, 재로딩을 안시키기때문에 처리결과를 강제로 변경시킴
          rowNode.data.campaignCustStatus = 'Distribution';
          rowNode.data.campaignCustStatusNm = '할당';
        }

        console.log('reload dd rowNode: ' , rowNode)
        rows.push(rowNode);
        this.subGridApi.redrawRows({ rowNodes: rows });  
      });
      
    },
    onSub2CellClicked(params) {
      const idx = params.rowIndex;
      const field = params.colDef.field;
      params.asId = this.saveForm.asId;

      if(this.subData2 && this.subData2.length>0){
        const vCustId = this.subData2[0].custId || '';
        params.custId = vCustId;
        
        this.openModel(params);
      }
      
    },
    
    /**
     * 접수/처리 상세 팝업 오픈
     */
    openModel(param) {
      console.log(param);
      let vm = this;
      this.$modal.open({
        width: 800,
        component: ReceptionModal,
        parent: this,
        props: {
          data: {
            asId: param.asId,
            custId: param.custId,
            firstTab: 'INIT1', /** 첫번째 TAB FLAG : 접수내역 */
            sortType: '',
            popHeadInfo: {}, //this.custParam.popHeadInfo,
            //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
            recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
            procsDt: this.$moment(param.procDt).format('YYYY-MM-DD')
          }
        },
        events: {
          close(data) {
            console.log('close', data);
          },
        }
      });
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    gridRefresh(gridOption) {
      let rows = [];
      let rowNode;
      if(gridOption === 'main'){
        const idx = this.selGridIdx;
        this.selGridIdx = -1; // 초기화
        this.selIdx = -1;
        rowNode = this.mainGridApi.getDisplayedRowAtIndex(idx);
        rows.push(rowNode);
        this.mainGridApi.redrawRows({ rowNodes: rows });

      } else {
        const idx = this.selGridIdx2;
        this.selGridIdx2 = -1; // 초기화
        this.selIdx2 = -1;
        rowNode = this.subGridApi.getDisplayedRowAtIndex(idx);
        rows.push(rowNode);
        this.subGridApi.redrawRows({ rowNodes: rows });  
      }   
    },
    goOpen() {
      // 조회

      let vm = this;

      // 초기화
      this.data = [];
      this.subData = [];
      this.subData2 = [];
      this.formClear();
      this.gridRefresh('main');
      this.gridRefresh('sub');
      this.search.selCampaignId = '';
      
      console.log('goOpen passed ');
      let vStartDt = this.search.startDt || '';
      let vEndDt = this.search.endDt || '';

      let nStartDt = vStartDt ? vStartDt.replace(/[^0-9]/g, '') : '';
      let nEndDt = vEndDt ? vEndDt.replace(/[^0-9]/g, '') : '';

      if(Number(nStartDt) > Number(nEndDt)){
        this.$swal({ type: 'warning', text: '검색 일자를 정확히 입력해주세요.' });

        return false;
      }

      this.search.todo = this.search.chkToday === 'Y' ? '1' : '';
        
      this.$store.commit('loading')

      const vform = {
        ...this.search,
        startDt : vStartDt,
        endDt : vEndDt,
        todaywork : this.search2.todaywork || '',
        campaignCustStatus: this.search2.campaignCustStatus || '',
        userId : this.search.agentMember || '0',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime : ''
      };

      this.$http.post(_url("/api/asMng/happyCallList/selectHappyCall"), vform).then(response => {
        console.log('response.data' , response.data);

        let vRespData = response.data;
        // 종료일자가 지나거나 혹은 전체 완료인 건은 제외시킴. 그러나 미완료건수가 있는 경우는 표시
        vRespData = vRespData.map(x=>{
          let vEndDt = x.endDt && x.endDt.length>=10 ? x.endDt.substring(0,10).replace(/[^0-9]/g, '') : '0';
          let curDt = this.$moment().format('YYYYMMDD');

          x.delRow = 'N';
          if(Number(vEndDt) < Number(curDt) && (x.nondoneCnt == '0' || x.nondoneCnt == '')){
            x.delRow = 'Y';
          }

          return x;    
        });

        vRespData = vRespData.filter(y=>y.delRow==='N');
        
        this.data = vRespData
                      .map(x=>{
                        x.startDt = x.startDt && x.startDt.length>=10 ? x.startDt.substring(0,10) : '';
                        x.endDt = x.endDt && x.endDt.length>=10 ? x.endDt.substring(0,10) : '';

                        const vCampaignTypeObj = vm.combos['campaignType'].filter(y=>y.key===x.campaignType);
                        if(vCampaignTypeObj && vCampaignTypeObj.length>0){
                          x.campaignTypeNm = vCampaignTypeObj[0].value;
                        }

                        const vCampaignStatusObj = vm.combos['campaignStatus'].filter(y=>y.key===x.campaignStatus);
                        if(vCampaignStatusObj && vCampaignStatusObj.length>0){
                          x.campaignStatusNm = vCampaignStatusObj[0].value;
                        }
                         
                        return x;
                      });

        if(vRespData && vRespData.length > 0){

          if(this.checkHideSubGrid(vRespData[0])){
            this.selGridIdx = -1;
            this.selIdx = -1;
            this.subData = [];
            this.subDataOrg = [];
            this.subData2 = [];
            this.btnSaveShow = false;
          } else {
            this.selGridIdx = 0;
            this.selIdx = 0;
            this.btnSaveShow = true;
            this.search.selCampaignId = vRespData[0].campaignId;
            vm.goDetail(1, vRespData[0].campaignId);
          }

          
        }

        this.dataOrg = this.data;

      }).catch((e) => {
        // console.error(e);
        // this.$swal({ type: 'success', text: '조회에 실패 했습니다.' })
    
      }).finally(() => {
        this.$store.commit('finish')
        
      });
    },
    checkHideSubGrid(vRespData){
      // 하위 그리드 표시 여부 체크

      let delRow = false;
        
      if(vRespData){

        let vEndDt = vRespData.endDt && vRespData.endDt.length>=10 ? vRespData.endDt.substring(0,10).replace(/[^0-9]/g, '') : '0';
        let curDt = this.$moment().format('YYYYMMDD');

        // 오늘날짜와 비교해서 종료일자가 지난경우
        if(Number(vEndDt) < Number(curDt)){
          delRow = true;
        }
      }

      return delRow;

    },
    goDetail(vOption, vCampaignId) {
      // 상세그리드 조회전 옵션에 맞게 조회조건 셋팅

      let vStartDt = '';
      let vEndDt = '';
      let vTodaywork = '';
      let vCampaignCustStatus = '';
      this.gridRefresh('sub');

      if(vOption === 1){
        // 첫번째 그리드 Search 옵션인경우

        vStartDt = this.search.startDt || '';
        vEndDt = this.search.endDt || '';

      } else {
        // 두번째 그리드 Search 옵션인경우

        if(!vCampaignId){
          vCampaignId = this.search.selCampaignId || '0';
        }

        let vStartDt = this.search2.startDt || '';
        // if(vStartDt === ''){
        //   vStartDt = this.search.startDt || '';
        // }

        let vEndDt = this.search2.endDt || '';
        // if(vEndDt === ''){
        //   vEndDt = this.search.endDt || '';
        // }

        vTodaywork = this.search2.todayType || '';

        vCampaignCustStatus = this.search2.campaignCustStatus3 || '';
        if(vCampaignCustStatus === ''){
          vCampaignCustStatus = this.search2.campaignCustStatus2 || '';
        }

        if(vCampaignCustStatus === ''){
          vCampaignCustStatus = this.search2.campaignCustStatus1 || '';
        }
        
      }

      let nStartDt = vStartDt ? vStartDt.replace(/[^0-9]/g, '') : '';
      let nEndDt = vEndDt ? vEndDt.replace(/[^0-9]/g, '') : '';

      if(Number(vStartDt) > Number(vEndDt)){
        this.$swal({ type: 'warning', text: '검색 일자를 정확히 입력해주세요.' });

        return false;
      }

      let vParam = {
        campaignId: vCampaignId || '0',
        campaignNm: this.search.campaignNm || '',
        campaignType: this.search.campaignType || '',
        campaignStatus: this.search.campaignStatus || '',
        startDt : vStartDt,
        endDt : vEndDt,
        todaywork : vTodaywork,
        campaignCustStatus: vCampaignCustStatus
      }

      this.goDetail2(vParam);
    },    
    async goDetail2(param) {
      // 주문상품목록 조회

      let vm = this
      console.log('goDetail param====', param)
      this.$store.commit('loading')

      this.btnSaveShow = false;
        
      const vform = {
        ...param,
        sortType: '',
        userId: this.search.agentMember || '0',
        page: this.search.page,
        totalpage: this.search.totalpage
      }

      // if(vform.campaignCustStatus==''){
      //   this.$store.commit('finish');
      //   this.$swal({ type: 'warning', text: '위의 그리드에서 캠페인을 선택해 주십시요.' });
      //   return false;
      // }

      console.log('goDetail2 vform====', vform);

      await this.$http.post(_url("/api/asMng/happyCallList/selectHappyCallDetail"), vform).then(response => {
        console.log('subData data : ' , response.data)
        this.selGridIdx2 = -1;
        /**========================두번째 그리드========================== */
        const vCustPageObj = response.data.campaignCustSelUserPage;
        if(vCustPageObj && vCustPageObj.length>0){
          vCustPageObj.map(x=>{
            x.createDt = x.createDt && x.createDt.length>10 ? x.createDt.substring(0,10) : '';
            x.asTelNo = _phone(x.asTelNo);
            x.boundTelNo = _phone(x.boundTelNo);

            const vCustTypeNm = this.combos['custType'].filter(y=>y.key===x.custType);
            if(vCustTypeNm && vCustTypeNm.length>0){
              x.custTypeNm = vCustTypeNm[0].value;
            }

            let vCampaignCustStatus = this.combos['allCampaignCustStatus'].filter(y=>y.catKey===x.campaignCustStatus);
            
            if(vCampaignCustStatus && vCampaignCustStatus.length>0){
              x.campaignCustStatusNm = vCampaignCustStatus[0].catNm;
            } 
            
            return x;
          });
          this.selGridIdx2 = 0;
        }
        
        this.subData = vCustPageObj;
        this.subDataOrg = vCustPageObj;

        this.getThirdData(response.data); // 세번째 그리드 조회

      }).finally(() => {
        this.$store.commit('finish');
        
        this.selGridIdx2 = 0;
        this.selIdx2 = 0;
      });
    },
    getThirdData(params){
      /**세번째 그리드 조회 */
console.log('getThirdData  params: ' , params);
      const vRepairObj = params.uspAsProcessSel1;
      if(!vRepairObj) {
        this.subData2 = [];
        return;
      }

      vRepairObj.map(x=>{
        const vChangeAsClassCdObj = this.combos['changeAsClass'].filter(y=>y.key===x.changeAsClassCd);
        if(vChangeAsClassCdObj && vChangeAsClassCdObj.length>0){
          x.changeAsClassCdNm = vChangeAsClassCdObj[0].value;
        }
          
        return x;
      })

      this.subData2 = vRepairObj;
      
      /**========================저장버튼 표시여부========================== */
      const vCustSelObj = params.uspCampaignCustSelItem;
      if(vCustSelObj && vCustSelObj.length > 0){
        this.saveForm.asId = vCustSelObj[0].asId;
        this.saveForm.campaignId = vCustSelObj[0].campaignId;
        this.saveForm.campaignCustId = vCustSelObj[0].campaignCustId;
        this.saveForm.stisfactionType = vCustSelObj[0].stisfaction;
        this.saveForm.description = vCustSelObj[0].description;
        

        const vBoundYn = vCustSelObj[0].boundYn; // 통화여부

        const auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===133)
        console.log('getThirdData  pass3: ', auth);
        console.log('getThirdData  pass4: ', vBoundYn);
        let GrantSelect = false // 조회권한
        if(auth && auth.length > 0){
          GrantSelect = auth[0].grantSelect === 'Y' ? true : false   
        }

        if(GrantSelect){
          this.btnSaveShow = true;
        } else {
          this.btnSaveShow = false;
        }

         
        const vAllObj = _.cloneDeep(this.combos['allCampaignCustStatus']);
        console.log('vAllObj=================:', vAllObj);
        const vStartStatus = vCustSelObj[0].campaignCustStatus;
        const vStartObj = _.cloneDeep(vAllObj.filter(x=>x.catKey==vStartStatus));
        console.log('vStartStatus vStartObj : ', vStartStatus, vStartObj, vAllObj)
        if(vStartObj && vStartObj.length>0){
          const vLvl = vStartObj[0].catLvl;
          let v4ParentObj;
          let v3ParentObj;
         
          if(vLvl === 4){
            v4ParentObj = vAllObj.filter(x=>x.catId==vStartObj[0].parentId);
            v3ParentObj = vAllObj.filter(x=>x.catId==v4ParentObj[0].parentId);

            const vTmpObj1 = vAllObj; 
            const vTmpObj2 = vAllObj;
            
            this.combos['svCampaignCustStatus3'] = vTmpObj1.filter(x=>x.parentId==vStartObj[0].parentId);
            this.combos['svCampaignCustStatus2'] = vTmpObj2.filter(x=>x.parentId==v4ParentObj[0].parentId);
            
            this.saveForm.svCampaignCustStatus3 = vStartStatus;
            this.saveForm.svCampaignCustStatus2 = v4ParentObj[0].catKey;
            this.saveForm.svCampaignCustStatus1 = v3ParentObj[0].catKey;

          } else if(vLvl === 3){

            const vTmpObj1 = vAllObj;
            
            v3ParentObj = (vAllObj.filter(x=>x.catId===vStartObj[0].parentId));
            this.combos['svCampaignCustStatus2'] = vTmpObj1.filter(x=>x.parentId==vStartObj[0].parentId);
            
            this.saveForm.svCampaignCustStatus2 = vStartStatus;
            this.saveForm.svCampaignCustStatus1 = v3ParentObj[0].catKey;

            this.combos['svCampaignCustStatus3'] = [];

          } else if(vLvl === 2){
            
            this.saveForm.svCampaignCustStatus1 = vStartStatus;
            this.combos['svCampaignCustStatus2'] = [];
            this.combos['svCampaignCustStatus3'] = [];
          }

          this.showCustStatus1 = this.combos['svCampaignCustStatus1'].length>0 ? true: false;
          this.showCustStatus2 = this.combos['svCampaignCustStatus2'].length>0 ? true: false;
          this.showCustStatus3 = this.combos['svCampaignCustStatus3'].length>0 ? true: false;

        }

      }

    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    async init() {
      this.$store.commit('loading');
      
      // 진행상태 : CampaignStatus
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 395}})
        .then(response => {
          this.combos['campaignStatus'] = response.data || [];
        });

      // 유형 : campaignType
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 107}})
        .then(response => {
          console.log('campaignType response :', response.data);
          this.combos['campaignType'] = response.data || [];
        });
        
      // 상담원
      await this.$http.post(`/api/asMng/happyCallList/agentList`, {
          ctiType: 'CampaignCustUseUser',
          ctiYn: 'Y',
          userId: this.$store.state.loginInfo.id
        })
          .then((response) => {
              console.log('agentMember response :', response.data)
              this.combos['agentMember'] = response.data.map(x=>{
                x.key = x.userId;
                x.value = x.userNm;
                return x;
              }) || [];

              if(this.$store.state.loginInfo.groupUId==3 || this.$store.state.loginInfo.groupUId==6) {
                this.search.agentMember = this.$store.state.loginInfo.id + '';
              } 

          });  

      // 금일 : todayType
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 158}})
        .then(response => {
          this.combos['todayType'] = response.data || [];
        });  
        
      // 처리결과 : CampaignCustStatus
      await this.$http.get(`/api/asMng/call/topkey`, {params: {topKey: 'CampaignCustStatus'}})
        .then(response => {
          this.combos['allCampaignCustStatus'] = response.data || [];
          this.combos['allCampaignCustStatus'] = this.combos['allCampaignCustStatus'].filter(x=>x.deleteYn==='N')
            .map(y=>{y.key=y.catKey; y.value=y.catNm; return y;});

          this.combos['campaignCustStatus'] = _.cloneDeep(this.combos['allCampaignCustStatus'].filter(x=>x.catLvl==2));
          this.combos['svCampaignCustStatus1'] = _.cloneDeep(this.combos['allCampaignCustStatus'].filter(x=>x.catLvl==2 && x.catKey !='Ready'));
          console.log('aa    init allCampaignCustStatus : ', response.data,  this.combos['allCampaignCustStatus'])
        });    
   
      // 처리결과 만족 라디오버튼 : StisfactionType
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 114}})
        .then(response => {
          this.combos['stisfactionType'] = response.data || [];
        });

      // 고객구분 : CustType
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 10}})
        .then(response => {
          this.combos['custType'] = response.data || [];
        });
  
      // AS처리유형 ID: ChangeAsClass 1레벨
      await this.$http.get(`/api/codeMng/combo`, {params: {parentId: 344}})
        .then(response => {
          this.combos['changeAsClass'] = response.data || [];
        });    

      
        

      this.createMainColumnDefs();
      this.createSubColumnDefs(); // 중간그리드
      this.createSubColumnDefs2(); // 장애접수 상세내역

      this.$store.commit('finish')

    },
    goSave(){
      // 저장

      const vm = this;

      if(this.saveForm.svCampaignCustStatus2 === 'Success'){
        // 통화성공이면 
        if(this.saveForm.stisfactionType === null || this.saveForm.stisfactionType === '' || this.saveForm.stisfactionType === '0'){
          this.$swal({ type: 'warning', text: '처리결과를 선택해 주십시오.' });
          return false;
        }
      }

      if(this.saveForm.svCampaignCustStatus1 === ''){
        this.$swal({ type: 'warning', text: '처리결과를 선택해 주십시오.' });
        return false;
      }

      if(this.showCustStatus2 && this.saveForm.svCampaignCustStatus2 === ''){
        this.$swal({ type: 'warning', text: '하위도 선택해주세요.' });
        return false;
      }

      if(this.showCustStatus3 && this.saveForm.svCampaignCustStatus3 === ''){
        this.$swal({ type: 'warning', text: '하위도 선택해주세요.' });
        return false;
      }

      let vCampaignCustStatus = '';
      let vCampaignCustStatusNm = '';
      let vStatusObj;
      
      if(this.showCustStatus3){
        vCampaignCustStatus = this.saveForm.svCampaignCustStatus3;
        vStatusObj = this.combos['svCampaignCustStatus3'].filter(x=>x.catKey === this.saveForm.svCampaignCustStatus3);

      } else if(this.showCustStatus2){
        vCampaignCustStatus = this.saveForm.svCampaignCustStatus2;
        vStatusObj = this.combos['svCampaignCustStatus2'].filter(x=>x.catKey === this.saveForm.svCampaignCustStatus2);
        
      } else {
        vCampaignCustStatus = this.saveForm.svCampaignCustStatus1;
        vStatusObj = this.combos['svCampaignCustStatus1'].filter(x=>x.catKey === this.saveForm.svCampaignCustStatus1);
      }

      if(vStatusObj && vStatusObj.length>0){
        vCampaignCustStatusNm = vStatusObj[0].catNm;
      }      
      
      let vStisfactionType = vm.saveForm.stisfactionType || '';
      if(vStisfactionType == 'null'){
        vStisfactionType = '';
      }

      const vform = {
        asId : vm.saveForm.asId,
        campaignId : vm.saveForm.campaignId,
        campaignCustId : vm.saveForm.campaignCustId,
        stisfaction : vStisfactionType,
        campaignCustStatus : vCampaignCustStatus,
        description : vm.saveForm.description
      }
     
      console.log('save ...vform: ', vCampaignCustStatus, vCampaignCustStatusNm, this.selIdx2, this.selGridIdx2);
      console.log('save ...vform: ', vform);
      
      this.$swal({
          type: 'warning',
          text: `저장하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
      }).then((result) => {
          if (result.value) {
              
              vm.$store.commit('loading')
              vm.$http.put(_url("/api/asMng/happyCallList/saveCampaignCust"), vform)
                  .then(response => {
                      vm.$swal({ type: 'success', text: '처리결과가 저장되었습니다.' });
                      // vm.formClear();
                  }).catch((e) => {
                     // console.error(e);
                     // vm.$swal({ type: 'success', text: '처리결과 저장에 실패했습니다' })
                  })
                  .finally(() => {
                      vm.$store.commit('finish');
              
                      // const vformParam = {
                      //   data: {...vform},
                      //   rowIndex: vm.selGridIdx2,
                      //   gr2CustStatusChange: (vCampaignCustStatus==='Distribution') ? 'Y' : 'N' // 할당인 경우
                      // };
                      // vm.reloadSubCell(vformParam);
                      
                      // 두번째 그리드가 선택이 안된 상태이면
                      if(vm.selGridIdx == 0 && vm.selGridIdx2 == -1 ){
                        vm.selGridIdx2 = 0;
                        vm.selIdx2 = 0;
                      }

                      // 두번째 그리드 갱신처리
                      vm.subData = _.cloneDeep(
                        vm.subDataOrg.map((x,index)=>{
                          if(index === vm.selIdx2){
                                x['campaignCustStatus'] = vCampaignCustStatus
                                x['campaignCustStatusNm'] = vCampaignCustStatusNm
                              }
                              
                              return x;
                          })
                      );

                      let vNoDoneNum = 0;
                      let vDoneNum = 0;

                      // 두번째 그리드로 할당갯수 카운트
                      vm.subData.map((x,index)=>{
                        if(x['campaignCustStatus'] == 'Distribution'){
                          vNoDoneNum++; // 할당갯수
                        }
                        return x;
                      });

                      if(vm.subData){
                        vDoneNum = vm.subData.length - vNoDoneNum;
                      }
                     
                      // 첫번째 그리드 갱신처리
                      vm.data = _.cloneDeep(
                        vm.dataOrg.map((x,index)=>{
                            if(index === vm.selIdx){
                              if(x['nondoneCnt'] && x['nondoneCnt'] != ''){
                                x['nondoneCnt'] = vNoDoneNum + '';
                              }
                              
                              if(x['doneCnt'] && x['doneCnt'] != ''){
                                x['doneCnt'] = vDoneNum + '';
                              }
                            }

                            return x;
                        })
                      );
                  });
          }
      });

    },
    async onSearhStatus1(param){
      // 화면중간 처리결과에서 1번째 select박스 변경시

      console.log('onSearhStatus1 change param : ', param)
      if(param === 'Complete'){
        this.search2.showSearchStatus2 = true;

        const vObj = this.combos['campaignCustStatus'].filter(x=>x.catKey===param);
        if(vObj && vObj.length>0){
          this.combos['campaignCustStatus2'] = _.cloneDeep(this.combos['allCampaignCustStatus'].filter(x=>x.catLvl==3));
          this.search2.campaignCustStatus2 = '';
        }
        
      } else {
        this.combos['campaignCustStatus2'] = [];

        this.search2.showSearchStatus2 = false;
        this.search2.showSearchStatus3 = false;

        this.combos['campaignCustStatus2'] = [];
        this.combos['campaignCustStatus3'] = [];
      }
    },
    async onSearhStatus2(param){
      // 화면중간 처리결과에서 2번째 select박스 변경시
      console.log('onSearhStatus2 start :',  param);
      if(this.saveForm.svCampaignCustStatus2 != 'Success'){
        this.saveForm.stisfactionType = '';
      }
      
      this.search2.showSearchStatus3 = true;
      const vObj = this.combos['campaignCustStatus2'].filter(x=>x.key===param);
      
      if(vObj && vObj.length>0){
        this.combos['campaignCustStatus3'] = _.cloneDeep(this.combos['allCampaignCustStatus'].filter(x=>x.catLvl==4 && x.parentId==vObj[0].catId));
        this.search2.campaignCustStatus3 = '';
        if(this.combos['campaignCustStatus3'].length ===0 ) {
          this.search2.showSearchStatus3 = false;
          this.combos['campaignCustStatus3'] = [];  
        }
      } else {
        this.search2.showSearchStatus3 = false;
        this.combos['campaignCustStatus3'] = [];
      }
      
    },
    onCustStatusChange1(param){
      // 화면하단 "처리결과에 만족하십니까?" 옆의 select박스 변경시
      //svCampaignCustStatus1 변경시
      console.log('onCustStatusChange1 change param : ', param)
      const vobj = this.combos['svCampaignCustStatus1'].filter(x=>x.key===param);

      // 통화성공이 아닌경우 초기화
      this.saveForm.stisfactionType = '';
        
      if(!vobj || vobj.length==0 || vobj[0].value == undefined) {
        this.showCustStatus2 = false;
        this.showCustStatus3 = false;

        this.saveForm.svCampaignCustStatus2 = '';
        this.saveForm.svCampaignCustStatus3 = '';
        this.combos['svCampaignCustStatus3'] = [];
        
        return false;
      }

      this.showCustStatus2 = false;
      this.showCustStatus3 = false;
      this.combos['svCampaignCustStatus2'] = _.cloneDeep(this.combos['allCampaignCustStatus'].filter(x=>x.parentId==vobj[0].catId));
      this.showCustStatus2 = this.combos['svCampaignCustStatus2'].length==0? false : true;    

      this.saveForm.svCampaignCustStatus2 = '';
      this.saveForm.svCampaignCustStatus3 = '';
      this.combos['svCampaignCustStatus3'] = [];
      
    },
    onCustStatusChange2(param){
      //svCampaignCustStatus2 변경시

      // 통화성공이 아닌경우 초기화
      if(this.saveForm.svCampaignCustStatus2 != 'Success'){
        this.saveForm.stisfactionType = '';
      }

      // 처리결과 : CampaignCustStatus
      console.log('onCustStatusChange2 change param : ', param)
      const vobj = this.combos['svCampaignCustStatus2'].filter(x=>x.key===param);

      if(!vobj || vobj.length==0 || vobj[0].value == undefined) {
        this.saveForm.svCampaignCustStatus3 = '';
        this.showCustStatus3 = false;

        return false;
      }

      this.showCustStatus3 = false;
      this.combos['svCampaignCustStatus3'] = _.cloneDeep(this.combos['allCampaignCustStatus'].filter(x=>x.parentId==vobj[0].catId));
      this.showCustStatus3 = this.combos['svCampaignCustStatus3'].length==0? false : true;

      this.saveForm.svCampaignCustStatus3 = '';

    },
    formClear(){
      // 폼내용 초기화

      const vSaveForm = {
        // 저장시 form
        asId: '',
        campaignId: '',
        campaignCustId: '',
        description: '',          // 사유
        stisfactionType: '',      // 처리결과 만족도
        svCampaignCustStatus1: '', // 처리결과
        svCampaignCustStatus2: '', // 처리결과
        svCampaignCustStatus3: '' // 처리결과
      }
      
      this.saveForm = vSaveForm;
    },
    onStypeChange(param){
        this.saveForm.svCampaignCustStatus1 = 'Complete';
        
        const vAllObj = _.cloneDeep(this.combos['allCampaignCustStatus']);
        let vTmpObj1 = this.combos['svCampaignCustStatus1'].filter(x=>x.catKey==='Complete');
        
        if(vTmpObj1 && vTmpObj1.length>0){
          this.showCustStatus2 = true;
          this.combos['svCampaignCustStatus2'] = vAllObj.filter(x=>x.parentId==vTmpObj1[0].catId);
          this.saveForm.svCampaignCustStatus2 = 'Success';
          this.showCustStatus3 = false;
          this.combos['svCampaignCustStatus3'] = [];
          this.saveForm.svCampaignCustStatus3 = '';
        }
    }
    

  },
  created() {

    if(this.$route.query.startDt == 'TodayComplete'){
      this.search.startDt = this.$moment().format('YYYY-MM-DD');
      this.search2.startDt = this.$moment().format('YYYY-MM-DD');
      this.search2.todaywork = 'TodayComplete';
    }else if(this.$route.query.startDt == 'TodayWork'){
      this.search.startDt = '';
      this.search2.startDt = '';
      this.search2.todaywork = 'TodayWork';
    }

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    this.search.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>